import { post } from "../utils/request";

export const createChristmasCard = async body => post(`christmas`, body);
